import { render, staticRenderFns } from "./MyCountWebpart.vue?vue&type=template&id=55acb64b"
import script from "./MyCountWebpart.ts?vue&type=script&lang=ts&external"
export * from "./MyCountWebpart.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports